import { render, staticRenderFns } from "./Scholarship.vue?vue&type=template&id=1944415a&scoped=true&"
import script from "./Scholarship.vue?vue&type=script&lang=js&"
export * from "./Scholarship.vue?vue&type=script&lang=js&"
import style0 from "./Scholarship.vue?vue&type=style&index=0&id=1944415a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1944415a",
  null
  
)

export default component.exports